// 业务集成
export let Integration = {
    path: 'integration',
    component: () =>
        import(
            /* webpackChunkName: "integration" */
            '@/views/back-stage/business-integration/integration.vue'
        ),
    children: [
        {
            path: 'servelist',
            name: 'servelist',
            component: () =>
                import(
                    /* webpackChunkName: "serve-list" */
                    '@/components/integration/serve-list/serve-list.vue'
                ),
        },
        {
            path: 'saplist',
            name: 'saplist',
            component: () =>
                import(
                    /* webpackChunkName: "sapconnection-list" */
                    '@/components/integration/sap-connection/sapconnection-list.vue'
                ),
        },
        {
            path: '*',
            redirect: 'servelist',
        },
    ],
};
